// extracted by mini-css-extract-plugin
export default {"button":"button__UQywQK","buttonRtl":"buttonRtl__Lgx92_"};